import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import Icon from '../../../components/Icon';
import filterProps from '../../../utils/filterProps';
class BranchDropdown extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: false,
        };
        this.toggle = () => {
            this.setState((prevState) => {
                return {
                    open: !prevState.open,
                };
            });
        };
    }
    render() {
        const { activeBranch, branchList, onBranchClick, mainBranch, t, ...other } = filterProps(this.props, ['i18n', 'tReady']);
        const branchName = activeBranch?.name ?? mainBranch.name;
        return (_jsx(_Fragment, { children: branchName && (_jsxs(Dropdown, { ...other, isOpen: this.state.open, toggle: this.toggle, size: "sm", children: [_jsxs(DropdownToggle, { caret: true, color: "outline-primary", disabled: !branchList.length, "data-testid": "branch-dropdown", children: [_jsx("span", { className: "d-md-none", children: _jsx(Icon, { name: "code-branch", className: "mr-2" }) }), _jsxs("span", { className: "d-none d-md-inline-block", children: [_jsxs("span", { children: [t('branch'), ":"] }), " ", _jsx("strong", { "data-testid": "active-branch-name", children: branchName })] })] }), branchList.length && (_jsx(DropdownMenu, { right: true, children: branchList.map((branch) => (_jsxs(DropdownItem, { onClick: () => onBranchClick(branch.id), disabled: activeBranch?.id === branch.id, "data-testid": branch.name, children: [_jsxs("span", { className: "d-md-none", children: [t('branch'), ": "] }), branch.name] }, branch.id))) }))] })) }));
    }
}
export default withTranslation()(BranchDropdown);
